<mat-card>
<div>
	<b>Individual Member Creation </b>
	
</div>
<br/>

<mat-card-content>
<form [formGroup]="individual">
	
	<mat-error *ngIf="formDataInvalid"> 
	One of mandatory data is missing
	</mat-error>
	<mat-error *ngIf="message"> 
	{{message}}
	</mat-error>
	
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Id" formControlName="id">
    </mat-form-field>
    <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Login Id" formControlName="loginUserId" required>
        <mat-error>
          Invalid Login Id
        </mat-error>
        <mat-hint>Min 8 char</mat-hint>
      </mat-form-field>

       <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="First Name" formControlName="firstName" required>
        <mat-error>
          Please provide a valid First Name
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>
      
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Middle Name" formControlName="middleName">
        <mat-error>
          Please provide a valid Middle Name
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>
      
      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Last Name" formControlName="lastName" required>
        <mat-error>
          Please provide a valid Last Name
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>
	
	  <mat-form-field>
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="individualTypeStr"  placeholder="Individual Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="individualType.key" *ngFor="let individualType of appData.individualTypes | keyvalue">{{ individualType.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Individual Type</mat-error>
		</mat-form-field>
	
	&nbsp;
	<mat-form-field *ngIf="submitBtnName == 'Update'" class="full-width-input spacing-field">
		<!--<mat-label>Inherited calendar color</mat-label>-->
		<input matInput [matDatepicker]="picker1" placeholder="Expiry Date" formControlName="expiryDate"
			[min]="todayDateFilter" [matDatepickerFilter]="customDateFilter">
		<mat-hint>MM/DD/YYYY</mat-hint>
		<mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
		<mat-datepicker #picker1 color="primary"></mat-datepicker>
	</mat-form-field>
	
	<mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Created For Company" [value]="this.appData.selectedComapnyId" formControlName="createdForCompany" required>
    </mat-form-field>
    
	
	
	
	<fieldset>
	  <legend>
		  <h3>Address
		  <button mat-button mat-raised-button color="primary" (click)="addAddress()">
			<mat-icon>add_circle</mat-icon>
		  </button>
		  </h3>
	  </legend> 
		
	
	
	<ng-container formArrayName="addressList" *ngFor="let addressGroup of addressArray.controls; let i = index">
	 <div [formGroupName]="i">
	  
	  <div *ngIf="i>0" class="divider-horiz-top-dotted-full-width">&nbsp;</div>
	  
	  <button mat-button mat-raised-button color="primary" (click)="deleteAddress(i)">
		<mat-icon>delete_forever</mat-icon>
	  </button>
 	 &nbsp;
 	 <mat-form-field [style.display]="'none'" class="full-width-input spacing-field">
       <input matInput placeholder="Id" formControlName="id">
     </mat-form-field>
	 <mat-form-field class="full-width-input spacing-field">
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="addressTypeStr"  placeholder="Address Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="addressType.key" *ngFor="let addressType of appData.addressTypes | keyvalue">{{ addressType.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Individual Type</mat-error>
	 </mat-form-field>
     <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Address Line 1" formControlName="addressLine1" required>
        <mat-error>
          Please provide a valid Address
        </mat-error>
        <mat-hint>Min 5, Max 50 char</mat-hint>
      </mat-form-field>

            <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Address Line 2" formControlName="addressLine2" required>
        <mat-error>
          Please provide a valid Address
        </mat-error>
        <mat-hint>Min 5, Max 50 char</mat-hint>
      </mat-form-field>

            <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="City" formControlName="city" required>
        <mat-error>
          Please provide a valid City
        </mat-error>
        <mat-hint>Max 30 char</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="State" formControlName="state" required>
        <mat-error>
          Please provide a valid State
        </mat-error>
        <mat-hint>Max 20 char</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Country" formControlName="country" required>
        <mat-error>
          Please provide a valid Country
        </mat-error>
        <mat-hint>Max 50 char</mat-hint>
      </mat-form-field>

      <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Pin Code/Zip Code" formControlName="pinCode" required>
        <mat-error>
          Please provide a Pin Code / Zip Code
        </mat-error>
      </mat-form-field>
	</div>
	</ng-container>
	
	</fieldset>
	
	 <fieldset>
	  <legend>
		   <h3>Contacts
			 <button mat-button mat-raised-button color="primary" (click)="addContact()">
				<mat-icon>add_circle</mat-icon>
			  </button>
		   </h3>
	  </legend> 
	 
	 <ng-container formArrayName="contactList" *ngFor="let contactGroup of contactArray.controls; let j = index">
	 <div [formGroupName]="j"> 
	 <div *ngIf="j>0" class="divider-horiz-top-dotted-full-width">&nbsp;</div>
	 
	 <button mat-button mat-raised-button color="primary" (click)="deleteContact(j)">
		<mat-icon>delete_forever</mat-icon>
	  </button>
 	&nbsp;
 	<mat-form-field [style.display]="'none'" class="full-width-input spacing-field">
       <input matInput placeholder="Id" formControlName="id">
    </mat-form-field>
	 <mat-form-field  class="full-width-input spacing-field">
		  <!-- <mat-label>Individual Type</mat-label> -->
		  <mat-select formControlName="contactType"  placeholder="Contact Type"  required>
		    <mat-option></mat-option>
		    <mat-option [value]="ct.key" *ngFor="let ct of appData.contactTypes | keyvalue">{{ ct.value }}</mat-option>
		  </mat-select>
		  <mat-error> Please select Contact Type</mat-error>
	 </mat-form-field>
       <mat-form-field class="full-width-input spacing-field">
        <input matInput placeholder="Contact Detail" formControlName="contactDetail" required>
        <mat-error>
          Please provide Contact Detail
        </mat-error>
      </mat-form-field>
      </div>
      </ng-container>
      </fieldset>
      
      
      <div>&nbsp;</div>
      <mat-grid-list class="my-card-row-height" cols="3" rowHeight="fit">
  		<mat-grid-tile>
  			<mat-card class="my-card" >
		      <mat-card-title>Roles ( {{roleList.selectedOptions.selected.length}} Selected )</mat-card-title>
		      <mat-card-content>
		         <mat-selection-list class="mat-selection-list-frame" formControlName="roleList"  placeholder="Role List"  #roleList>
				  <mat-list-option [value]="role.id" *ngFor="let role of appData.allRoles.value ">
				    {{role.id}}
				     <mat-divider></mat-divider>
				  </mat-list-option>
				  
				  <!-- <mat-error> Please select at least one Role</mat-error> -->
				</mat-selection-list>
		      </mat-card-content>
		    </mat-card> 
		
	  </mat-grid-tile>

		<mat-grid-tile>	  
		<mat-card class="my-card" >
		  	<mat-card-title>Privileges ( {{privList.selectedOptions.selected.length}} Selected )</mat-card-title>
		  	<mat-card-content>
			<mat-selection-list class="mat-selection-list-frame" formControlName="privList"  placeholder="Privileges List"  #privList>
			  <mat-list-option [value]="priv.id" *ngFor="let priv of appData.allPrivileges.value ">
			    {{priv.id}}
			     <mat-divider></mat-divider>
			  </mat-list-option>
			  
			</mat-selection-list>
			 </mat-card-content>
			 </mat-card> 
		</mat-grid-tile>
	</mat-grid-list>
</form>
<div>&nbsp;</div>
<button mat-raised-button color="primary" [disabled]="!individual.valid" *ngIf="!formSubmitAttempt" 
				(click)="onSubmit(submitBtnName)">{{submitBtnName}}</button>
<button mat-button *ngIf="formSubmitAttempt">
	<mat-icon>autorenew</mat-icon>
</button>
&nbsp;
<button mat-raised-button color="primary" [disabled]="!individual.valid" *ngIf="!formSubmitAttempt && submitWithCreateLinkBtn" 
				(click)="onSubmit(submitWithCreateLinkBtnName)">{{submitWithCreateLinkBtnName}}</button>
&nbsp;
<button mat-raised-button color="primary" (click)="clearIndividualSystem()">Reset</button>


</mat-card-content> </mat-card>
